import { api_DELETE, api_GET, api_GET_Unauthorize, api_POST, api_POST_files, api_PUT } from './_api';

const transportador_api = {
    GetList: (credenciamento = null, status = null) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetList${credenciamento ? `?credenciamento=${credenciamento}` : ""}${status ? `?status=${status}` : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetAll: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetAll`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetListDisponiveis: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Transportador/GetListDisponiveis`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetUsuariosIntegradores: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetUsuariosIntegradores`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetItemDisponivel: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetItemDisponivel/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetItemByCnpj: (cpfcnpj) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Transportador/GetItemByCnpj/${cpfcnpj}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Transportador", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Transportador", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    InsertUsuarioIntegrador: (usuariointregador_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Transportador/InsertUsuarioIntegrador`, usuariointregador_Id)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    RemoveUsuarioIntegrador: (usuariointregador_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`Transportador/RemoveUsuarioIntegrador/${usuariointregador_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    PostDocumentos: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_files("Transportador/InsertDocumentosTransportador", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    }
}

export default transportador_api;